<section>
    <sp-dashboard-past-display
        [fiscalYear]="selectedFiscalYear$ | async">
    </sp-dashboard-past-display>
</section>
